module.exports = __webpack_public_path__ + "img/w3_circle_list_image_light.a60fb9a9.a60fb9a9.png";